export default __webpack_public_path__ + "static/media/Vysakh.30a25433.jpg";